import { Constants } from "../../../../utils";
import ModifyWebhook from "./modifyWebhook";
import useViewModel from "../../viewModel";
import Webhooks from "./webhooks";
import Webhook from "./webhook";

const SMHI = ({ onEditClick = () => {}, ...props }) => {
  const { webhooks, updateWebhookSignal, smhiSupportedDevice } = useViewModel();

  const toggleActivation = async (_) => {
    if (!_.url) {
      onEditClick({ ..._, enabled: true });
    } else {
      await updateWebhookSignal({ signal: _.signal, enabled: !_.enabled });
    }
  };

  return (
    <>
      {!smhiSupportedDevice ? (
        <Webhook
          {...props}
          webhook={webhooks[0]}
          toggleActivation={toggleActivation}
          onLearnMore={() => window.open(Constants.Project.smhiHelpUrl)}
          configureWebhook={(_) => onEditClick(_)}
        />
      ) : (
        <Webhooks
          {...props}
          webhooks={webhooks}
          supportedDevice={smhiSupportedDevice}
          toggleActivation={toggleActivation}
          onLearnMore={() => window.open(smhiSupportedDevice.helpUrl)}
          configureWebhook={(_) => onEditClick(_)}
        />
      )}
    </>
  );
};

SMHI.ModifyWebhook = ModifyWebhook;
export default SMHI;
